import axios from 'axios'

// 在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 4
axios.defaults.retryDelay = 1000
const _axios = axios.create({
  baseURL:
    typeof PROJECT_CONFIG !== 'undefined' && typeof PROJECT_CONFIG.BASE_URL !== 'undefined'
      ? document.location.protocol + '//' + (PROJECT_CONFIG.BASE_URL.substring(0, 7) === 'http://' ? PROJECT_CONFIG.BASE_URL.replace('http://', '') : PROJECT_CONFIG.BASE_URL)
      : ''
})
// request interceptor
_axios.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

export default _axios
